<div class="width-100 gap-05 flex column">
  @if (getData) { @if (daysData$ | async; as daysData) { @if (daysData) {
  <app-pvds [daysData]="daysData" />
  <app-days [daysData]="daysData" />
  } @else {
  <app-pvds [daysData]="loadingData" />
  <app-days [daysData]="loadingData" />

  } } } @else {
  <app-pvds [daysData]="loadingData" />
  <app-days [daysData]="loadingData" />
  }
</div>
